/* xs-scope-css.js v1.0 (2026-09-23) — 描述/A+ 里 <style> 的 CSS 只作用于描述本身(老板 0923「ADD TO CART 文字跑左边」案:
   A+ 模板里写了全局 .btn{display:inline-flex;padding:18px 36px…} 漏到整页,改坏主题加购按钮;一类问题全站修)。
   做法: 找产品描述容器里的 <style>,给容器打唯一类 .xs-scope-N,用 CSSOM 把每条规则的选择器前缀成「.xs-scope-N 选择器」;
   :root/html/body 改写成容器本身(变量照常可用);@media 递归;@keyframes/@font-face 不动。零依赖,幂等,描述被主题重渲染后自动重跑。 */
(function () {
  'use strict';
  var HOSTS = '.vk-a-plus-scope,.xs-aplus,.product-single__description,.product__description,.product-description,.rte,.product-block--description,.product-info__description,[class*="description"] .rte';
  var n = 0;
  function scopeSel(sel, cls) {
    return sel.split(',').map(function (s) {
      s = s.trim(); if (!s) return s;
      if (/^(:root|html|body)$/i.test(s)) return '.' + cls;
      s = s.replace(/^(html|body)\s+/i, '');
      if (s.indexOf('.' + cls) === 0) return s;
      return '.' + cls + ' ' + s;
    }).join(', ');
  }
  function scopeRules(rules, cls) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      try {
        if (r.type === 1 && r.selectorText) { var ns = scopeSel(r.selectorText, cls); if (ns !== r.selectorText) r.selectorText = ns; }
        else if (r.cssRules && (r.type === 4 || r.type === 12 || r.type === 3)) scopeRules(r.cssRules, cls); // @media / @supports / @import(ignored)
      } catch (e) { }
    }
  }
  function run() {
    var styles = document.querySelectorAll('style:not([data-xs-scoped])');
    for (var i = 0; i < styles.length; i++) {
      var st = styles[i]; var host = st.closest ? st.closest(HOSTS) : null;
      if (!host) continue;
      if (host.closest('head')) continue;
      var cls = host.getAttribute('data-xs-scope');
      if (!cls) { cls = 'xs-scope-' + (++n); host.setAttribute('data-xs-scope', cls); host.classList.add(cls); }
      try { if (st.sheet && st.sheet.cssRules) { scopeRules(st.sheet.cssRules, cls); st.setAttribute('data-xs-scoped', '1'); } } catch (e) { }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 50); });
  if (window.MutationObserver) { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 100); }).observe(document.documentElement, { childList: true, subtree: true }); }
  window.__xsScopeCss = { run: run, v: '1.0' };
})();
